export default {"src":"/_next/static/media/plug_and_play.68d73c2e.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};